module.exports = __webpack_public_path__ + "img/egg_fish.5bb82440.svg";